<template>
  <div class="audit-main">
    <div class="animated fadeIn">
      <b-card class="header mb-0" header-tag="header" footer-tag="footer">
        <div slot="header" class="col-sm-10 col-form-label font-weight-bold uppercase">
          {{ $t('audit.audit_log') }}
        </div>

        <!-- Filters -->
        <b-row>
          <!-- Filter by audit type -->
          <b-col cols="2">
            <fieldset class="audit__fieldset__box">
                <legend class="audit__fieldset__box-legend">{{ $t('audit.filter.audit_type_legend') }}</legend>
                <multiselect
                    v-model="filter.auditType"
                    :options="auditTypeOptions"
                    label="name"
                    track-by="value"
                    :multiple="false"
                    >
                </multiselect>
            </fieldset>
          </b-col>

          <!-- filter audit date range -->
          <b-col cols="2">
            <fieldset class="audit__fieldset__box">
              <legend class="audit__fieldset__box-legend">{{ $t('audit.filter.date_range_legend') }}</legend>
              <b-input-group style="border: none !important;">
                <date-range-picker style="width: 100%" ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" opens="center" :locale-data="date_locale" :ranges="ranges" @update="updateDateRange"></date-range-picker>
              </b-input-group>
            </fieldset>
          </b-col>

          <!-- filter audit user -->
          <b-col cols="3">
            <fieldset class="audit__fieldset__box" style="height: 57px;">
                <legend class="audit__fieldset__box-legend">{{ $t('audit.filter.user_email_legend') }}</legend>
                <md-field class="customer-email-input">
                    <md-input :placeholder="$t('audit.filter.user_email_placeholder')" v-model="filter.userEmailTextSearch"></md-input>
                </md-field>
            </fieldset>
          </b-col>

          <!-- filter search -->
          <b-col cols="3">
            <fieldset class="audit__fieldset__box" style="height: 57px;">
                <legend class="audit__fieldset__box-legend">{{ $t('audit.filter.action_name_legend') }}</legend>
                <md-field class="customer-email-input">
                    <md-input :placeholder="$t('audit.filter.action_name_placeholder')" v-model="filter.actionName"></md-input>
                </md-field>
            </fieldset>
          </b-col>

          <b-col cols="1" class="d-flex justify-content-center">
            <b-button class="btn btn__reset" variant="info" @click="onResetFilters">{{ $t('common.reset') }}</b-button>
          </b-col>
        </b-row>

        <!-- Log Info Screen -->
        <b-row class="mt-4">
          <b-col cols="12">
            <div>
              <b-table
                class="pointer"
                show-empty
                stacked="md"
                :items="dataTable.items"
                :fields="dataTable.fields"
                hover
                @row-clicked="handleRowClicked"
              >
                <template v-slot:cell(object_name_localised)="{item,value}">
                  <router-link :to="item.routelink" target="_blank">{{value}}</router-link> 
                </template>

                <template slot="row-details"> 
                  <div v-if="auditDetailLoader" style="height : 20em" >
                    <div class="audit-popup-bike-loader"></div>
                  </div>
                  <div v-else v-for="text in change" class="ml-4">
                    <LogDetailComponent :detailedLoggerObj="text" />
                  </div>
                </template>
              </b-table>

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="pagination.total" :per-page="pagination.perPage" v-model="pagination.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: pagination.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="pagination.perPage" :options="pagination.options" class="mb-3"/>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

      </b-card>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import LogDetailComponent from './components/LogDetailComponent.vue';

const MIN_TEXT_LENGTH_SEARCH = 3;
const MAX_TEXT_LENGTH_SEARCH = 255;
const DELAY_TIME = 1000;
const initFilter = {
  startAt: moment().format('YYYY-MM-DD'),
  endAt: moment().format('YYYY-MM-DD'),
  auditType: '',
  userEmailTextSearch: '',
  actionName: ''
}

let vm=null;

const AUDIT_ACTION_CREATE = "create";
const AUDIT_ACTION_UPDATE = "update";
const AUDIT_ACTION_DELETE = "delete";
const AUDIT_ACTION_CLONE  = "clone";
const AUDIT_ACTION_PUSHED_TO_PROD = "pushToProduction";
const AUDIT_ACTION_REMOVED_FROM_PROD = "removedToProduction";
const AUDIT_ACTION_ACTIVATED = 'activated';
const AUDIT_ACTION_DEACTIVATED = 'deactivated';
const MENU = "Menu";
const COMBO = "Combo";
const STORE = "Store";
const COUPON = "Coupon";

export default {
  name: 'AuditTrailLogs',
  components:{
    Multiselect,
    DateRangePicker,
    LogDetailComponent
  },
  data: function () {
    return {
      auditTypeOptions: [
        {
          name: "All",
          value: ""
        },
        {
          name: "Menu",
          value: "Menu"
        },
        {
          name: "Coupon",
          value: "Coupon"
        },
        {
          name: "Store",
          value: "Store"
        },
        {
          name: "Combo",
          value: "Combo"
        },
      ],
      watchInPause: false,
      filter: { ...initFilter },
      auditTypeDefinitionGeneral: {
        [AUDIT_ACTION_CREATE]: this.$t('audit.action_created'),
        [AUDIT_ACTION_UPDATE]: this.$t('audit.action_updated'),
        [AUDIT_ACTION_DELETE]: this.$t('audit.action_deleted'),
        [AUDIT_ACTION_CLONE]: this.$t('audit.action_cloned'),
        [AUDIT_ACTION_PUSHED_TO_PROD]: this.$t('audit.action_pushed_to_prod'),
        [AUDIT_ACTION_REMOVED_FROM_PROD]: this.$t('audit.action_removed_from_prod'),
        [AUDIT_ACTION_ACTIVATED]: this.$t('audit.action_activated'),
        [AUDIT_ACTION_DEACTIVATED]: this.$t('audit.action_deactivated')
      },
      auditModuleLocalisedConversions: {
        'Menu':this.$t('audit.module_menu'),
        'Coupon':this.$t('audit.module_coupon'),
        'Store':this.$t('audit.module_store'),
        'Combo':this.$t('audit.module_combo'),
      },
      auditDetailsAll:[],
      pagination: {
        options: [10, 20, 50, 100, 200],
        currentPage: 1,
        total: 0,
        totalPages: 0,
        perPage: 10,
      },
      dataTable: {
        items: [],
        fields: [
          {
            key: 'datetime_modified',
            label: this.$t('audit.datetime'),
          },
          {
            key: 'module_localised',
            label: this.$t('audit.module'),
          },
          {
            key: 'object_name_localised',
            label: this.$t('audit.name'),
          },
          {
            key: 'action_name_modified',
            label: this.$t('audit.action'),
          },
          {
            key: 'user_detail_modified',
            label: this.$t('audit.user'),
          }
        ],
      },
      change : [],
      detailsRow : null,
      auditDetailLoader : false,
      lang : this.$session.get('lang'),
      time_zone : this.$moment.tz.guess(),
      today_is : this.$moment(new Date()).format('YYYY-MM-DD'),
      country_code : this.$store.getters.config.country_code,
      log_detail_api_response : [],
      store_time_zone : '',
    }
  },
  methods: {
    async onResetFilters() {
      this.watchInPause = true;
      this.filter = {...initFilter}
      await this.refreshData();
      this.watchInPause = false;
    },
    handleRowClicked(item, index){
      //expand row for update cases only
      if(item.action_name !== AUDIT_ACTION_UPDATE) {
        return false;
      }
      const { detailsRow } = this
      if (detailsRow && detailsRow !== item) {
        detailsRow._showDetails = false;
      }
      this.$set(item, "_showDetails", !item._showDetails);
      this.change= [];  //reset
      this.getMonitoredLogChanges(item.uuid, item.action_name);
      this.detailsRow = item;
    },
    getMonitoredLogChanges(uuid, action_name) {
      let value_after, value_before;
      let text = [];
      //vm.$bus.$emit('loading', 'block');
      this.auditDetailLoader = true;
      vm.axios.audit.getDetailedLogInsight(uuid, (response) => {
        if(response.data.data[0].change == undefined) {
          this.auditDetailLoader = false;
          return;
        }
        else if(action_name==AUDIT_ACTION_CREATE && response.data.data[0].object_name==undefined){
          this.auditDetailLoader = false;
          return;
        }
        this.log_detail_api_response = response.data.data[0];
        if(this.log_detail_api_response.action_type == STORE) {
          this.store_time_zone = this.client_tz[this.country_code.toLowerCase().trim()];
        }
        response.data.data[0].change.forEach(item => {
          //if(item.kind == 'E') {
            if(!this.validateInput(item)){ 
              return;
            }
            value_before=value_after='';
            if(action_name == AUDIT_ACTION_UPDATE) {
              value_after = (item.item!=undefined) ? item.item.rhs : item.rhs;
              value_before = (item.item!=undefined )? item.item.lhs : item.lhs;
              let format;
              if(typeof value_after === 'object') {
                value_after = JSON.stringify(value_after);
              }
              if(typeof value_before == 'object') {
                value_before = JSON.stringify(value_before);
              }
              if(typeof value_before == 'string') {
                format = this.checkDateValidationAndFormat(value_before);
                if(format!=='') {
                  if(format == 'HH:mm:ss') {
                    let data = this.today_is+' '+value_before;
                    let timezone = (this.store_time_zone!='')?this.store_time_zone:this.time_zone;
                    value_before = vm.convertUTCToTimeZone(data,timezone).format(format);
                  }
                  else {
                    value_before = vm.convertUTCToTimeZone(value_before,this.time_zone).format(format);
                  }
                }
              }
              if(typeof value_after == 'string') {
                format = this.checkDateValidationAndFormat(value_after);
                if(format!==''){
                  if(format == 'HH:mm:ss') {
                    let data = this.today_is+' '+value_after;
                    let timezone = (this.store_time_zone!='')?this.store_time_zone:this.time_zone;
                    value_after = vm.convertUTCToTimeZone(data,timezone).format('HH:mm:ss')
                  } 
                  else {
                    value_after = vm.convertUTCToTimeZone(value_after,this.time_zone).format(format);
                  }
                }
              }
              text.entity = item.path ? item.path.join(" : ") : '';
            }
            text.value_before  = value_before;
            text.value_after   = value_after;
            text.type          = item.kind;
            text.action        = action_name;
            this.change.push(text);
            text = [];
          //}
        });
        this.auditDetailLoader = false;
      });
    },
    validateInput(item) {
      if(item.kind=='A') {
        return true;
      }
      let type_lhs  = typeof item.lhs;
      let type_rhs  = typeof item.rhs;
      if(item.rhs === null && item.lhs === null) {
        return false;
      }
      else if(item.rhs === undefined && item.lhs === undefined) {
        return false;
      }
      else if((type_lhs === 'object' || type_lhs=='string') && type_rhs == 'undefined') {
        if(_.isEmpty(item.lhs)) {
          return false;
        }
      }
      else if((type_rhs === 'object' || type_rhs=='string') && type_lhs == 'undefined') {
        if(_.isEmpty(item.rhs)) {
          return false;
        }
      }
      return true;
    },
    checkDateValidationAndFormat(item) {
      let date_format_1 = this.$moment(item, 'YYYY-MM-DD HH:mm:ss');
      let date_format_2 = this.$moment(item, 'YYYY-MM-DD');
      let date_format_3 = this.$moment(item, 'HH:mm:ss')
      if (date_format_1 && date_format_1.isValid() && item == date_format_1.format('YYYY-MM-DD HH:mm:ss')) {
        return 'YYYY-MM-DD HH:mm:ss';
      }
      else if(date_format_2 && date_format_2.isValid() && item == date_format_2.format('YYYY-MM-DD')) {
        return 'YYYY-MM-DD';
      }
      else if(date_format_3 && date_format_3.isValid() && item == date_format_3.format('HH:mm:ss')) {
        return 'HH:mm:ss';
      }
      return '';
    },
    updateDateRange(val) {
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD');
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD');
      this.refreshData();
    },
    seachByUserEmailOrAuditName(property) {
      if (this.filter[property].length > 0 && this.filter[property].length < MIN_TEXT_LENGTH_SEARCH || this.filter[property].length > MAX_TEXT_LENGTH_SEARCH) {
        return;
      }
      this.refreshData();
    },
    refreshData() {
      this.getListOfAuditLogs();
    },
    getListOfAuditLogs() {
      let params='';

      let _data = {
        limit: vm.pagination.perPage,
        page: vm.pagination.currentPage,
        action_type: vm.filter.auditType ? vm.filter.auditType.value : '',
        user_email: vm.filter.userEmailTextSearch,
        action_name: vm.filter.actionName,
        start_date: vm.filter.startAt,
        end_date: vm.filter.endAt
      };
      // process to send via get method
      for (let key in _data) {
        params += key + '=' + _data[key] + '&'
      }
      params = params.slice(0, -1);

      vm.axios.audit.listAllAuditRecords(params, (response) => {
        vm.auditDetailsAll = response.data.data;
        const { pagination, items } = response.data.data
        vm.dataTable.items = this.modifyResultSetForDataTable(items);
        vm.pagination = {
            ...vm.pagination,
            currentPage: +pagination.current_page,
            total: +pagination.total,
            totalPages: +pagination.total_pages,
            perPage: +pagination.per_page,
          }
      });
    },
    modifyResultSetForDataTable(items) {
      items.forEach((item, idx)=>{
        items[idx].datetime_modified = this.$moment(item.datetime).format('MMM Do, YYYY @ HH:mm:ss');
        items[idx].action_name_modified = (vm.auditTypeDefinitionGeneral[item.action_name]!=undefined) ? vm.auditTypeDefinitionGeneral[item.action_name] : item.action_name;
        if( item.user_detail == '' || item.user_detail == undefined || item.user_detail.email == null || item.user_detail.email == ''){
          items[idx].user_detail_modified =  'N/A';
        } else {
          items[idx].user_detail_modified = item.user_detail.email;
        }
        //localise action name.
        items[idx].module_localised = vm.auditModuleLocalisedConversions[item.action_type];
        if(typeof item.object_name == 'string' && JSON.parse(item.object_name)[this.lang]) {
          item.object_name = JSON.parse(item.object_name);
        }

        items[idx].object_name_localised = (item.object_name!=undefined && item.object_name[this.lang]) ? item.object_name[this.lang]:'N/A';
        if(item.action_type == COMBO) {
          items[idx].routelink = { name: 'combo_edit',  params: { uuid: item.object_uuid }};
        }
        else if(item.action_type == COUPON) {
          items[idx].routelink = { name: 'coupon_edit',  params: { id: item.object_uuid }};
        }
        else if (item.action_type == MENU) {
          items[idx].routelink = { name: 'menu_edit',  params: { id: item.object_uuid }};
        }
        else if(item.action_type== STORE) {
          items[idx].routelink = { name: 'outlets_edit',  params: { uuid: item.object_uuid }};
        }
      });
      return items;
    }
  },
  computed: {
    date_locale: function () {
      let format = this.format_date_range_locale();
      format.format = 'YYYY/MM/DD';
      if (this.$refs.drange) {
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges: function () {
      return this.format_date_ranges()
    }
  },
  created : function () {
    this.debouncedInput = _.debounce(this.seachByUserEmailOrAuditName, DELAY_TIME)
    vm=this;
    vm.getListOfAuditLogs();
  },
  watch:{
    'filter.userEmailTextSearch': function (_) {
      if (this.watchInPause) return;
      this.debouncedInput('userEmailTextSearch');
    },
    'filter.actionName': function (_) {
      if (this.watchInPause) return;
      this.debouncedInput('actionName');
    },
    'filter.auditType': function (_) {
      if (this.watchInPause) return;
      vm.refreshData();
    },
    'pagination.perPage' : function (val) {
      vm.refreshData();
    },
    'pagination.currentPage' : function (val) {
      vm.refreshData();
    }
  }
}
</script>
<style scoped>
.btn__reset {
  margin-top: .5rem;
  padding: 0 1rem;
  font-size: 16px;
  color: white;
}
.btn__reset:focus {
  box-shadow: none;
}
.audit__fieldset__box {
  border: 1px solid #00000026;
  border-radius: 3px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.audit__fieldset__box-legend {
  font-size: 12px;
  margin-left: 10px;
  width: max-content;
  color:#6B6E79;
  margin-bottom: -3px;
}
.customer-email-input {
  min-height: 42px;
  margin: 0;
  padding: 0 1rem;
}

.customer-email-input::after {
  background-color: rgba(34,36,38,.15);
}

.customer-email-input::before {
  background-color: #4dbd74;
}

.customer-email-input input::-webkit-input-placeholder {
  font-size: 14px;
  color: hsla(0,0%,74.9%,.87);
}

.audit-popup-bike-loader {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999999;
  width: 97%;
  height: 20em;
  background-image: url("../../../../static/img/loader-bike.gif");
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.audit__fieldset__box > .input-group > div > div.form-control {
  border: none !important;
}

.audit__fieldset__box > .multiselect > .multiselect__tags {
  border: none !important;
}

.audit-main .table-hover tbody tr:hover td {
  background: #E9EAEC;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  position: relative;
  z-index: 1;
  border-radius: 2px;
  transition: .3s cubic-bezier(.4,0,.2,1);
  transition-property: background-color;
  will-change: background-color;
}

.audit-main .b-table-details td > div {
  max-height: 20em;
  height: max-content;
  overflow: auto;
  width: 100%;
  cursor: text;
}
.audit_changed_key {
    padding: 4px;
    border-width: 3px;
    background: #fee0c8;
    border-radius: 4px;
}
.action_changed_value {
    padding: 4px;
    border-width: 3px;
    background: #eae8ff;
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/audit-trail/BaseForm.vue